.spotifyEmbed {
  border: 0;
}
